import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { accountRoute } from '../../routes';
import axios from 'axios';
import qs from 'qs';
import baseUrl from '../../utils/baseUrl';

import { dispatchError, dispatchMsg } from '../../actions/errors';

import connect from '../../utils/connect';

import Splitter from './block/splitter';
import AccountBlockCategoryList from './block/categoryList';
import ContentBlock from './block/content';
import ConfirmDialog from '../form/confirm';
import Spinner from '../svg/spinner';
import Dropdown from '../dropdown/dropdown';

// import pluralize from 'pluralize';
import { DateFormatter } from '../../utils/date';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

// import translate from '../../utils/translate';

import * as actions from '../../actions/account';

const UNPUBLISHED = 'UNPUBLISHED';
const IN_REVIEW = 'IN_REVIEW';
const PUBLISHED = 'PUBLISHED';

class AccountEditorialList extends Component {

	constructor(props) {
		super();

		this.state = {
			waiting: false,
			isProfile: undefined,
		};
	}

	componentWillMount() {
		let isProfile = this.isProfile();
		let fetchFunction = actions[(isProfile) ? 'fetchProfileEditorials' : 'fetchUserEditorials'];

		isProfile && redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);

		this.props.dispatch(actions.clearCollection());
		if (this.props.router.params.type) {
			this.state.isProfile = isProfile;
			this.setWaiting(true);
			this.props.dispatch(fetchFunction(this.props.router.params.type, () => this.setWaiting(false)));
		}
	}

	componentWillReceiveProps(nextProps) {
		let isProfile = this.isProfile(nextProps);
		let fetchFunction = actions[(isProfile) ? 'fetchProfileEditorials' : 'fetchUserEditorials'];

		if (this.props.router.params.type !== nextProps.router.params.type || this.state.isProfile !== isProfile) {
			this.props.dispatch(actions.clearCollection());
			this.state.isProfile = isProfile;
			this.setWaiting(true);
			this.props.dispatch(fetchFunction(nextProps.router.params.type, () => this.setWaiting(false)));
		}
	}

	render() {
		let editorialTypes = this.props.users.profile.editorials;
		let contentType = (function(editorials, slug) {
			if (editorialTypes) {
				for (var i = 0; i < editorialTypes.length; i++) {
					if (editorialTypes[i].slug === slug) {
						return editorialTypes[i].name;
					}
				}
			}

			return '';
		})(editorialTypes, this.props.router.params.type);
		let title = contentType;

		if (this.isProfile() && this.props.users && this.props.users.profile && this.props.users.profile.name) {
			title += ' by ' + this.props.users.profile.name;
		}

		let contentTitles = {
			UNPUBLISHED: 'Unpublished',
			IN_REVIEW: 'In review',
			PUBLISHED: 'Published',
		};

		let content = {
			UNPUBLISHED: [],
			IN_REVIEW: [],
			PUBLISHED: [],
		};

		for (var i = 0; i < this.props.account.editorials.length; i++) {
			if (this.props.account.editorials[i].status) {
				content[this.props.account.editorials[i].status].push(this.props.account.editorials[i]);
			} else {
				console.warn('Editorial has no status!');
			}
		}

		let isProfile = this.isProfile();
		let fetchFunction = actions[(isProfile) ? 'fetchProfileEditorials' : 'fetchUserEditorials'];

		return (
			<div className='account-editorial'>
				<Helmet title='The FWA - Account' />
				<ConfirmDialog ref='confirm' />

				<ContentBlock title={title} sticky={true} browser={this.props.browser}>
					<div className='account-block-content__content__buttons'>
						{/*
							<Link to={accountRoute(`/profile/editorial/${this.props.router.params.type}/create`)} className='button button--dark '>Create {pluralize(contentType, 1).toLowerCase()}</Link>
						*/}
					</div>
				</ContentBlock>

				{this.state.waiting && this.renderWaiting()}

				{!this.state.waiting && <Splitter className='hide-mobile' />}

				{!this.state.waiting && Object.keys(contentTitles).map((key, i) => {
					let title = contentTitles[key];
					return (
						<div key={title}>
							<AccountBlockCategoryList
								browser={this.props.browser}
								compComponent={EditorialListItem}
								title={title}
								content={content[key]}
								type={key}
								waiting={this.state.waiting}
								data={{
									dispatch: this.props.dispatch,
									refreshData: () => {
										this.setWaiting(true);
										this.props.dispatch(fetchFunction(this.props.router.params.type, () => this.setWaiting(false)));
									},
									isProfile,
								}}
							/>
							<Splitter />
						</div>
					);
				})}

			</div>
		);
	}

	isProfile(props = false) {
		props = props || this.props;
		return (
			this.props.router &&
			this.props.router.routes &&
			this.props.router.routes[3] &&
			this.props.router.routes[3].source === 'profile');
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountEditorialList);

export class EditorialListItem extends Component {
	static propTypes = {
		type: PropTypes.string.isRequired,
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		data: PropTypes.object.isRequired,
	};

	static defaultProps = {
		type: '',
		item: {},
	};

	render() {
		let { item } = this.props;
		let STATUS_UNPUBLISHED = (this.props.type === UNPUBLISHED) || false;
		//let STATUS_IN_REVIEW = (this.props.type === IN_REVIEW) || false;
		//let STATUS_PUBLISHED = (this.props.type === PUBLISHED) || false;
		let CAN_EDIT = this.props.item.canEdit || false;
		let date = new DateFormatter((this.props.type === PUBLISHED) ? item.releaseDate : item.editedDate);

		let title = item.title || '';
		let userName = ((item.user) ? item.user.name : '') || '';

		//return (<div>{item.id}</div>);
		let basePath = (this.props.data && this.props.data.isProfile) ? '/profile/editorial/' : '/editorial/';

		return (
			<div className='editoriallist__content__item'>
				<h3 className='editoriallist__content__item__head'>{title}</h3>
				<span className='editoriallist__content__item__author'>— {userName}</span>
				<span className='editoriallist__content__item__foot'>
					{(this.props.type === PUBLISHED) ? 'Published: ' : 'Last edited: '}
					{date.monthDateAndYear}
				</span>

				{(STATUS_UNPUBLISHED || CAN_EDIT) && <a key='menu' className='editoriallist__button button button--action' ref='menu'>...</a>}

				{(STATUS_UNPUBLISHED || CAN_EDIT) && (
					<Dropdown key='dropdown' attachTo={() => this.refs.menu} pointTo='AUTO' browser={this.props.browser}>
						<ol key='dropdown-ol'>
							<li key='link-edit'><Link to={accountRoute(`${basePath}${item.types.slug}/${item.id}`)} onClick={(e) => e.stopPropagation()}>Edit</Link></li>
							{STATUS_UNPUBLISHED && <li key='link-publish'><Link to='' onClick={(e) => this.publish(e, item)}>Ready to publish</Link></li>}
						</ol>
					</Dropdown>
				)}
			</div>
		);
	}

	stopPropagation(e) {
		e.stopPropagation();
	}

	publish(e, item) {
		e.preventDefault();
		// console.log('PUBLISH: ' + this.props.item.slug);
		// console.log(item, this.props);
		const type = this.props.item.types.slug;

		axios.post(`${baseUrl}/api/account/editorials/${item.id}/publish`, qs.stringify({
			type,
		}))
		.then((res) => {
			this.catchMessage(res, false);
			if (this.props.data && this.props.data.refreshData) {
				this.props.data.refreshData();
			}
		})
		.catch((res) => {
			this.catchMessage(res, true);

			// console.log(this.props);
			if (this.props.data && this.props.data.refreshData) {
				this.props.data.refreshData();
			}
		});
	}

	catchMessage(res, error = false) {
		const fn = error ? dispatchError : dispatchMsg;
		if (res.data && res.data.message) {
			this.props.data.dispatch(fn(res.data.message));
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/editorialList.js
 **/